import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useWorkSpaceContext } from 'modules/locations/contexts/workSpaces/WorkSpacesContext'
import { useDeleteWorkSpace } from 'modules/locations/hooks/useDeleteWorkspace'
import { WorkSpaceNode } from 'modules/space_control/hooks/useWorkSpaces'

interface Props {
  toggleModal: () => void
  workSpace: WorkSpaceNode
  onSuccess: () => void
}

const DeleteModal = ({ toggleModal, workSpace, onSuccess }: Props) => {
  const { onDeleted } = useWorkSpaceContext()
  const { deleteWorkSpace } = useDeleteWorkSpace()

  const onSubmit = async () => {
    track(trackingEvents.spaceControl.deleteSpace, {})
    if (workSpace.id) {
      const result = await deleteWorkSpace(workSpace)
      const handled = handleResult(result, (_errors) => {})

      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('common.deleted_successfully'),
        })
        onDeleted?.()
        onSuccess?.()
        toggleModal()
      } else {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('common.save_error'),
        })
      }
    }
  }

  return (
    <Modal
      title={i18n.t('settings.locations.location.work_spaces.delete_modal.title', {
        space_name: workSpace.name,
      })}
      illustration="alert"
      description={i18n.t('settings.locations.location.work_spaces.delete_modal.description', {
        space_name: workSpace.name,
      })}
      onClose={toggleModal}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={toggleModal}>
            {i18n.t('settings.locations.location.work_spaces.delete_modal.cancel')}
          </Button>
          <Button submit>
            {i18n.t('settings.locations.location.work_spaces.delete_modal.submit')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default observer(DeleteModal)
